import _str from "shared/util/_str";
import isApp from "shared/util/isApp";

const isMobile = process.env.PLATFORM === "mobile";

export const FIELD_TRANSITION_SPEED = 400;

export const VALIDATION_TIMEOUT = isMobile ? 1200 : 600;

export const FIELDS = {
	EMAIL: "email",
	REGISTRATION: "registration",
	PASSWORD: "password",
};

// used in analytics
export const FIELD_NAMES = {
	gender: "gender",
	orientation: "orientation",
	gayPrivacy: "gayPrivacy",
	location: "location",
	birthday: "birthday",
	email: "email",
	screenname: "screenname",
	password: "password",
	captcha: "captcha",
	realname: "realname",

	// this should be used as a last resort!
	// it overrides the default continue button
	// (for example, used on desktop to have a continue button on one side
	// and fb on the other)
	continueButton: "continueButton",
};

export const SUBFIELDS = {
	[FIELDS.REGISTRATION]: [FIELDS.PASSWORD],
};

export const PROMPTS = {
	[FIELDS.EMAIL]: _str("Welcome! Who are you?"),
	[FIELDS.REGISTRATION]: _str("Create a password"),
};

export const DESKTOP_PROMPTS = {
	[FIELDS.EMAIL]: _str("Welcome! Who are you?"),
	[FIELDS.REGISTRATION]: _str("Create a password"),
};

export const FACEBOOK_SIGNUP_STATES = {
	ready: "ready",
	connecting: "connecting",
	loggingIn: "loggingIn",
	errorContinue: "errorContinue",
	errorGiveUp: "errorGiveUp",
	success: "success",
};
export const FACEBOOK_STATE_STRINGS = {
	ready: _str("Sign Up with Facebook"),
	connecting: _str("Connecting…"),
	loggingIn: _str("Logging you in…"),
	errorGiveUp: _str("We couldn’t connect you to Facebook!"),
	errorContinue: _str("Something went wrong, try again?"),
	success: _str("Success!"),
};

export const URLS = {
	SPLASH: "/",
	SIGNUP: "/signup",
	SMS_SIGNUP: "/signup/phone",
	LOGIN: "/login",
	LOGIN_APPS: "/login-direct",
};

export const getLoginLink = () => (isApp() ? URLS.LOGIN_APPS : URLS.LOGIN);

export const TSP_REFRESH_TOKEN_LOCAL_STORAGE_KEY = "tsp_refresh_token";

export const REGISTRATION_TYPES = {
	PASSWORD: "password",
	PHONE: "phone number",
};



// WEBPACK FOOTER //
// ./src/apps/signup/util/constants.js